module.exports = __webpack_public_path__ + "img/jieduan.6a5d7ac4.png";